export default `
function sayHi(name) {
  console.log("Hello " + name + "!");
}

sayHi("World");

console.log({ name: "John", age: 21 });
`.trim() + "\n".repeat(12);
